import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from '@core/services/loading/loading.service';
import { environment } from '@env';
import { primengTranslate } from '@pco-front-assets/js/primeng-translates';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { PcoToastComponent } from './core/components/pco-toast/pco-toast.component';
import { AuthService } from './core/services/auth/auth.service';

/**
 * Initialize PCO enviroment vars
 */
window['pco'] = {};
window.pcoLocation = window.pcoLocation || window.location;

/**
 * App component
 */
@Component({
  selector: 'app-root',
  imports: [PcoToastComponent, CommonModule, RouterOutlet, AsyncPipe, ConfirmDialogModule],
  standalone: true,
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  /**
   * App component constructor
   */
  constructor(
    private readonly primeng: PrimeNGConfig,
    public loading: LoadingService,
    private readonly authService: AuthService
  ) {
    this.primeng.setTranslation(primengTranslate);
    this.primeng.ripple = true;

    /**
     * MSAL service start
     */
    this.authService.start();

    if (environment.env === 'prod') this.dynatrace();
    if (environment.env === 'uat') this.dynatrace();
  }

  /**
   * Load dynatrace monitoring service
   */
  dynatrace() {
    const script = document.createElement('script');
    script.src = environment.dynatrace_source;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }

  /**
   * Init from App componet
   */
  ngOnInit() {
    /**
     * Show a console log version
     */
    const styles =
      'background: linear-gradient(135deg , #492279 0%,  #0CC8BD 100%); color: #fff; border-radius: 5px; font-size: 18px; font-weight: bold; padding: 4px 8px;';
    window.console.log(`%cPuntosColombia v${environment.version}:${environment.env}`, styles);
  }
}
